import { FunctionComponent } from 'react'
import { Card, CardContent } from '@black-bear-energy/rucksack'

export const Surface: FunctionComponent<SurfaceProps> = ({ children }) => {
  return (
    <Card sx={{ display: 'flex', flex: 1 }}>
      <CardContent
        sx={{
          width: '100%',
          '&:last-child': {
            paddingBottom: 2,
          },
        }}
      >
        {children}
      </CardContent>
    </Card>
  )
}

interface SurfaceProps {
  children: React.ReactNode
}
